import { getPagePath, trans } from '@spotahome/soyuz/client';

import RelevantLink from './RelevantLink';

import './RelevantLinkSection.scss';

const SECTIONS = [
  {
    titleKey: 'error_page.relevant_links.how-it-works',
    routeId: 'how-it-works',
    imgSrc: 'https://static.spotahome.com/images/how-it-works.svg'
  },
  {
    titleKey: 'error_page.relevant_links.list-property',
    routeId: 'externals.landlord-landing',
    imgSrc: 'https://static.spotahome.com/images/list-property.svg'
  },
  {
    titleKey: 'error_page.relevant_links.support-center',
    routeId: 'support',
    imgSrc: 'https://static.spotahome.com/images/support-center.svg'
  }
];

const RelevantLinkSection = () => {
  return (
    <section className="relevant-link-section">
      <p className="relevant-link-section__title">
        {trans('error_page.relevant_links.title')}
      </p>
      <div className="relevant-link-section__list">
        {SECTIONS.map(({ titleKey, routeId, imgSrc }) => (
          <RelevantLink
            key={titleKey}
            title={trans(titleKey)}
            href={getPagePath(routeId)}
            imgSrc={imgSrc}
          />
        ))}
      </div>
    </section>
  );
};

export default RelevantLinkSection;
